
module.exports = function()
{
    this.title = null;
    this.message = "";
    this.confirmationMessage = "";
    this.onYes = null;
    this.onNo = null;
}